import React from "react"
import { API_ENDPOINTS } from "../../helpers/api"
import { formatDate } from "../../helpers/download"
import ResourceListModal from "./ResourceListModal"

const renderMeta = (wheel) => `${wheel.slices_count} choices · ${formatDate(wheel.created_at)}`

const LoadWheelModal = ({ onClose, onLoad }) => (
  <ResourceListModal
    title="Load from Account"
    endpoint={API_ENDPOINTS.WHEELS}
    listKey="wheels"
    itemKey="wheel"
    emptyText="No saved wheels yet"
    loadingText="Loading saved wheels..."
    renderMeta={renderMeta}
    onLoad={onLoad}
    onClose={onClose}
  />
)

export default LoadWheelModal
